<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon class="mr-5 scale-150">contacts</mat-icon>
            <h1 class="text-3xl font-medium">Clients</h1>
        </div>
    </header>
    @if (clientsStore.isFulfilled()) {
        <button
            mat-flat-button
            color="primary"
            (click)="openEditClient()">
            Add client
        </button>
        <table
            mat-table
            [dataSource]="dataSource">
            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Title
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.title }}
                </td>
            </ng-container>
            <ng-container matColumnDef="sourceType">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Source
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ OfferSourceType[element.sourceType] }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    class="self-end"
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu">
                        Manage
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            mat-menu-item
                            (click)="openEditClient(element)">
                            Edit client
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
